import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderDetailTaxComponent } from '../order-detail-tax/order-detail-tax.component';
import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderDetailTaxService } from '../order-detail-tax.service';
import { OrderDetailTax } from '../order-detail-tax';

@Component({
    selector: 'app-order-detail-tax-list',
    templateUrl: './order-detail-tax-list.component.html',
    styleUrls: ['./order-detail-tax-list.component.css'],
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderDetailTaxListComponent implements OnInit {
	reservation: any;
	orderDetails: any[] = [];
	reservationId: any;
	taxPercentages: any[]=[];
	taxPCT: any;
	orderDetailTaxId: any;
	displayTaxPctPopUp = false;
	isSpinner = false;
	expandTaxes: boolean = false;
	constructor(
		private orderDetailTaxService: OrderDetailTaxService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.reservationId = data.reservationId,
			this.orderDetails = data.orderDetails,
		// 	this.showFilter = data?.showFilter;
		// this.showPagination = data?.showPagination;
		this.statuses = orderDetailTaxService.statuses;
		this.taxPercentages = orderDetailTaxService.taxPercentages;
	}


	// data
	@Input() showFilter = false;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;

	@Output() doDelete = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	orderDetailTaxs: any;
	orderDetail: any;
	orderDetailTax: OrderDetailTax;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'quantity', header: '#', width: 'auto' },
		{ field: 'listPrice', header: 'Price ', width: 'auto' },
		{ field: 'listPriceAdjustmentAmount', header: '$ Discount ', width: 'auto' },
		{ field: 'total', header: 'Total', width: 'auto' },
	];

	// Tree table data
	treeTableData: any[] = [];

	taxError: string = '';
	isTaxValid: boolean = false;

	onTaxInput(event: any) {
		const input = event.target.value;

		// Regex: 0–2 digits before dot, optional dot with up to 3 digits after
		const validPattern = /^[0-9]{0,2}(\.[0-9]{0,3})?$/;

		if (input === '' || validPattern.test(input)) {
			const numericValue = parseFloat(input);

			if (!isNaN(numericValue) && numericValue > 20) {
				this.taxError = 'Tax percentage cannot exceed 20.';
				this.isTaxValid = false;
			} else {
				this.taxError = '';
				this.isTaxValid = input !== '' && !isNaN(numericValue);
			}

			this.taxPCT = input;
		} else {
			this.taxError = 'Only 2 digits before and 3 digits after decimal allowed.';
			this.isTaxValid = false;
		}
	}



	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
			
			// Transform data to tree table format
			this.transformToTreeTable();
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/**
	 * Transform order details to tree table format
	 */
	transformToTreeTable() {
		this.treeTableData = this.orderDetails.map(orderDetail => {
			const parentNode: any = {
				data: {
					name: orderDetail.name,
					quantity: orderDetail.quantity,
					listPrice: orderDetail.listPrice,
					listPriceAdjustmentAmount: orderDetail.listPriceAdjustmentAmount,
					total: orderDetail.subTotal,
					type: 'orderDetail',
					orderDetailData: orderDetail
				},
				children: [],
				expanded: this.expandTaxes
			};

			// Add tax children if they exist
			if (orderDetail.orderDetailTaxes && orderDetail.orderDetailTaxes.length > 0) {
				parentNode.children = orderDetail.orderDetailTaxes.map((tax: any) => ({
					data: {
						name: `${tax.name}(${tax.taxPCT}%)`,
						quantity: '',
						listPrice: '',
						listPriceAdjustmentAmount: '',
						total: tax.taxAmount,
						type: 'tax',
						taxData: tax,
						orderDetailTaxId: tax.orderDetailTaxId
					},
					leaf: true
				}));
			}

			return parentNode;
		});
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		// Handle both tree node data and direct tax object
		const taxData = event.taxData || event;
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete OrderDetailTax Id# ' + taxData.orderDetailTaxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(taxData);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	// loadLazy(event: LazyLoadEvent) {
	// 	try {
	// 		this.loading = true;
	// 		this.lazyLoadEvent = event;

	// 		console.log(
	// 			' event.first:' + event.first
	// 			+ '  |  event.rows:' + event.rows
	// 			+ '  |  event.sortField:' + event.sortField
	// 			+ '  |  event.sortOrder:' + event.sortOrder
	// 			+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
	// 			+ '  |  event.globalFilter:' + event.globalFilter
	// 			+ '  |  event.filters:' + JSON.stringify(event.filters)
	// 		);

	// 		/*
	// 		*
	// 		* Default Sort
	// 		*/
	// 		// https://stackoverflow.com/questions/679915/how-do-i-orderDetailTax-for-an-empty-javascript-object
	// 		// if we are NOT filtering and we are NOT sorting, apply a default sort
	// 		if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
	// 			event.multiSortMeta = [];
	// 			event.multiSortMeta.push({ field: 'createDate', order: -1 });
	// 		}

	// 		const pageNumber = Math.round(event.first / event.rows);
	// 		this.orderDetailTaxService.findByFilter(
	// 			pageNumber, event.rows,
	// 			event.sortField,
	// 			event.sortOrder,
	// 			event.multiSortMeta,
	// 			event.globalFilter,
	// 			event.filters).pipe(first()).subscribe(

	// 				(res: any) => {
	// 					this.datasource = res.data.reviews;
	// 					this.recordTotal = res.page.recordTotal;
	// 					this.orderDetailTaxs = res.data.orderDetailTaxs;
	// 					console.log(JSON.stringify(res.page));
	// 				},
	// 				(err: any) => {
	// 					console.log('reviews list error!: ' + JSON.stringify(err));
	// 					this.alertService.error(err);
	// 				},
	// 				() => { this.loading = false; }
	// 			);

	// 		if (this.datasource) {
	// 			this.orderDetailTaxs = this.datasource.slice(event.first, (event.first + event.rows));
	// 		}
	// 	} catch (error) {
	// 		console.log('loadLazy(' + event + ')' + error);
	// 	}
	// }

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderDetailTax: OrderDetailTax) {
		try {
			this.formLoading = true;
			this.orderDetailTaxService.update(orderDetailTax)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderDetailTaxs.map((orderDetailTax, i) => {
							if (orderDetailTax.orderDetailTaxId === res.data.orderDetailTax.orderDetailTaxId) {
								this.orderDetailTaxs[i] = res.data.orderDetailTax;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderDetailTax: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderDetailTax));

			this.formLoading = true;
			this.orderDetailTaxService.delete(orderDetailTax.orderDetailTaxId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						
						// Remove from the corresponding order detail's tax array
						this.orderDetails.forEach(orderDetail => {
							if (orderDetail.orderDetailTaxes) {
								const index = orderDetail.orderDetailTaxes.findIndex((tax: any) => tax.orderDetailTaxId === orderDetailTax.orderDetailTaxId);
								if (index !== -1) {
									orderDetail.orderDetailTaxes.splice(index, 1);
								}
							}
						});
						
						// Refresh the tree table data
						this.transformToTreeTable();
						
						this.recordTotal = this.orderDetails.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderDetailTax ' + orderDetailTax.orderDetailTaxId + ' Deleted', life: 3000 });
						this.doDelete.emit(orderDetailTax);
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderDetailTax ' + orderDetailTax.orderDetailTaxId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OrderDetailTax'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderDetailTaxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOrderDetailTaxCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderDetailTax: OrderDetailTax) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderDetailTax: orderDetailTax,
			title: 'Edit OrderDetailTax'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderDetailTaxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOrderDetailTaxCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOrderDetailTaxCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderDetailTaxCB(orderDetailTax: OrderDetailTax) {
		console.log('Adding OrderDetailTax: ' + JSON.stringify(orderDetailTax));
		// if we don't have a orderDetailTaxs array yet...
		if (!this.orderDetailTaxs) {
			this.orderDetailTaxs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orderDetailTaxs.unshift(orderDetailTax);

		// no idea what this is but it is required to update the array
		this.orderDetailTaxs = [...this.orderDetailTaxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetailTax ' + orderDetailTax.orderDetailTaxId + ' Added', life: 3000 });
	}

	updateOrderDetailTaxCB(orderDetailTax: OrderDetailTax) {
		console.log('Updating OrderDetailTax: ' + JSON.stringify(orderDetailTax));
		let itemIndex = this.orderDetailTaxs.findIndex((item: any) => item.orderDetailTaxId === orderDetailTax.orderDetailTaxId);
		this.orderDetailTaxs[itemIndex] = orderDetailTax;

		// no idea what this is but it is required to update the array
		this.orderDetailTaxs = [...this.orderDetailTaxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetailTax ' + orderDetailTax.orderDetailTaxId + ' Updated', life: 3000 });
	}

	deleteOrderDetailTaxCB(orderDetailTax: OrderDetailTax) {
		console.log('Removing OrderDetailTax: ' + orderDetailTax);
		this.orderDetailTaxs.splice(this.orderDetailTaxs.indexOf(orderDetailTax), 1);
		this.recordTotal = this.orderDetailTaxs.length;

		// no idea what this is but it is required to update the array
		this.orderDetailTaxs = [...this.orderDetailTaxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetailTax ' + orderDetailTax.orderDetailTaxId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderDetailTaxs ? this.first === (this.orderDetailTaxs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderDetailTaxs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderDetailTax: any) {
		if (orderDetailTax?.status) {
			const status = this.statuses.find((e: any) => e.value == orderDetailTax.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
	grandTotal(){
		let total = 0
		this.orderDetails.forEach(orderDetail => {
			total += orderDetail?.total
		});
		return total;
	}

	totalTax(){
		let total = 0
		this.orderDetails.forEach(orderDetail => {
			total += orderDetail?.tax
		});
		return total;
	}
	totalAmount(){
		let total = 0
		this.orderDetails.forEach(orderDetail => {
			total += orderDetail?.subTotal
		});
		return total;
	}

	onTaxPercentageChange(taxPercentage: any)
	{
		this.taxPCT = taxPercentage;
	}

	updateTaxPercentage() {
		try {
			// stop here if form is invalid
			const data = {
				orderDetailTaxId: this.orderDetailTaxId,
				taxPCT: this.taxPCT
			};
			console.log('orderDetailTax: ' + JSON.stringify(data));
			this.formLoading = true;
			this.isSpinner = true;

			this.orderDetailTaxService.update(data)
				.subscribe(
					(res: any) => {
						this.doUpdate.emit(res.data.orderDetailTax);
						this.isSpinner = false;
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.displayTaxPctPopUp = false;
					},
					(err: any) => {
						this.isSpinner = false;
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.isSpinner = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onRowEdit(orderDetailTax: any) {
		this.taxPCT = orderDetailTax?.taxPCT;
		this.orderDetailTaxId = orderDetailTax?.orderDetailTaxId;
		this.displayTaxPctPopUp = true;
	}

	showTaxes() {
		this.expandTaxes = !this.expandTaxes;
		this.treeTableData = this.treeTableData.map(node => ({ ...node, expanded: this.expandTaxes }));
	}
}
